module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-1900.11d6968a.svg";